module.exports = __webpack_public_path__ + "assets/ac097b07849613e4c39d9e65126ecd8b.svg";